import React, { useState } from "react";
import MarketingBanner2 from "../marketing/MarketingBanner2";
import {
  boardTypes,
  getTexts,
  propertyFromArray,
  roomTypes,
  roomViews,
  views,
  airportcity,
} from "../utils";

import { FormattedMessage, FormattedNumber } from "react-intl";
import { FaPlaneDeparture } from "react-icons/fa";
import { MdAirplanemodeActive, MdOutlineLocalOffer } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { selectSearch } from "amadeusredux/lib/searchSlice";

import { selectSystem, setView } from "amadeusredux/lib/systemSlice";
import {
  //searchAlternativeTransports,
  //searchAlternativeFlights,
  searchBetterOffers,
  setMarked,
} from "amadeusredux/lib/hotelSlice";
import { availabilityAndPriceCheck, getLink2Share, setOfferMemo } from "amadeusredux/lib/api";

import {
  availableOfferData,
  getPassinfo,
  getTermsAndConditions,
  setInboundView,
  setTheOffer,
} from "amadeusredux/lib/bookingSlice";

import { MdContentCopy } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";
import { FaShareAlt, FaHeart } from "react-icons/fa";
import FlightLocations from "./FlightLocations";
import OfferFlight from "./OfferFlight";
import AvailabilityButton from "../AvailabilityButton";
import CancellationOptions from "../CancellationOptions";

const nf = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2 });

const df = new Intl.DateTimeFormat("de-DE", {
  weekday: "short",
  day: "2-digit",
  month: "2-digit",
});

const df2 = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const tf = new Intl.DateTimeFormat("de-DE", {
  hour: "2-digit",
  minute: "2-digit",
});

const checkBetter = (offer, suboffer) => {
  let betterOffer = 0;
  let betterOption = { better: false, options: [] };
  if (
    !(
      offer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
        .DepartureTime ===
      suboffer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
        .DepartureTime &&
      offer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
        .DepartureTime ===
      suboffer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
        .DepartureTime
    )
  )
    return betterOption;

  if (offer.PriceInfo.Price.value > suboffer.PriceInfo.Price.value)
    return betterOption;

  if (
    offer.TourOperator.TourOperatorName !==
    suboffer.TourOperator.TourOperatorName
  )
    return betterOption;

  let roomTypeOfferOrder = roomTypes.find(
    (e) => e.value === offer.OfferServices.Package.Accommodation.Room.RoomType
  ).order;
  let roomTypeSubOfferOrder = roomTypes.find(
    (e) =>
      e.value === suboffer.OfferServices.Package.Accommodation.Room.RoomType
  ).order;

  betterOffer = betterOffer + (roomTypeSubOfferOrder - roomTypeOfferOrder);
  if (roomTypeSubOfferOrder - roomTypeOfferOrder < 0) {
    return betterOption;
  }

  if (roomTypeSubOfferOrder - roomTypeOfferOrder > 0) {
    betterOption.options.push("roomType");
  }

  if (
    offer.OfferServices.Package.Accommodation.Room.RoomName !==
    suboffer.OfferServices.Package.Accommodation.Room.RoomName
  ) {
    betterOffer = betterOffer + 1;
    betterOption.options.push("roomName");
  }

  let boardTypeOfferOrder = boardTypes.find(
    (e) => e.value === offer.OfferServices.Package.Accommodation.BoardType
  ).order;
  let boardTypeSubOfferOrder = boardTypes.find(
    (e) => e.value === suboffer.OfferServices.Package.Accommodation.BoardType
  ).order;

  betterOffer = betterOffer + (boardTypeSubOfferOrder - boardTypeOfferOrder);

  if (boardTypeSubOfferOrder - boardTypeOfferOrder < 0) {
    return betterOption;
  }

  if (boardTypeSubOfferOrder - boardTypeOfferOrder > 0) {
    betterOption.options.push("boardType");
  }

  let roomViewOfferOrder = roomViews.find(
    (e) => e.value === offer.OfferServices.Package.Accommodation.Room.RoomView
  ).order;
  let roomViewSubOfferOrder = roomViews.find(
    (e) =>
      e.value === suboffer.OfferServices.Package.Accommodation.Room.RoomView
  ).order;

  betterOffer = betterOffer + (roomViewSubOfferOrder - roomViewOfferOrder);

  if (roomViewSubOfferOrder - roomViewOfferOrder < 0) {
    return betterOption;
  }

  if (roomViewSubOfferOrder - roomViewOfferOrder > 0) {
    betterOption.options.push("roomView");
  }

  let transferinclOffer = 0;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclOffer = 1;
    }
  }

  let transferinclSubOffer = 0;
  if (suboffer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(suboffer.OfferProperties.TransferInfos) &&
      suboffer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclSubOffer = 1;
    }
  }

  betterOffer = betterOffer + (transferinclSubOffer - transferinclOffer);

  if (transferinclSubOffer - transferinclOffer < 0) {
    return betterOption;
  }

  if (transferinclSubOffer - transferinclOffer > 0) {
    betterOption.options.push("transfer");
  }

  let railandflyOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflyOffer = 1;
    }
  }

  let railandflySubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflySubOffer = 1;
    }
  }
  betterOffer = betterOffer + (railandflySubOffer - railandflyOffer);

  if (railandflySubOffer - railandflyOffer < 0) {
    return betterOption;
  }

  if (railandflySubOffer - railandflyOffer > 0) {
    betterOption.options.push("railandfly");
  }

  let cancellationOffer = 0;
  if (offer.OfferProperties.CancellationOption === "Free")
    cancellationOffer = 3;
  if (offer.OfferProperties.CancellationOption === "Addable")
    cancellationOffer = 2;
  if (offer.OfferProperties.CancellationOption === "Paid")
    cancellationOffer = 1;

  let cancellationSubOffer = 0;
  if (suboffer.OfferProperties.CancellationOption === "Free")
    cancellationSubOffer = 3;
  if (suboffer.OfferProperties.CancellationOption === "Addable")
    cancellationSubOffer = 2;
  if (suboffer.OfferProperties.CancellationOption === "Paid")
    cancellationSubOffer = 1;

  betterOffer = betterOffer + (cancellationSubOffer - cancellationOffer);

  if (cancellationSubOffer - cancellationOffer < 0) {
    return betterOption;
  }

  if (cancellationSubOffer - cancellationOffer > 0) {
    betterOption.options.push("cancellation");
  }

  if (betterOffer > 0) betterOption.better = true;

  return betterOption;
};

export default function HotelClassicViewOffer(props) {
  const {
    offer,
    hotels,
    geodata,
    stations,
    parentOffer,
    betterOption,
    alternatives,
  } = props;

  const dispatch = useDispatch();
  const sessionId = useSelector((state) => state.system.sessionId);

  const airports = stations.Station;
  const hotel = hotels.Hotel.find(
    (e) =>
      e.HotelID === offer.OfferServices.Package.Accommodation.HotelRef.HotelID
  );
  const { loading } = useSelector(selectSystem);

  const checkids = useSelector((state) => state.hotel.checkids);

  const outboundFlight = offer?.OfferServices?.Package?.Flight?.OutboundFlight;
  const inboundFlight = offer?.OfferServices?.Package?.Flight?.InboundFlight;
  const searchOptions = useSelector(selectSearch);

  //console.log(offer);
  //console.log(offer.TourOperator.TourOperatorCode);

  const getBetterOffers = () => {
    dispatch(
      searchBetterOffers({
        fromDate: outboundFlight.FlightDeparture.DepartureDate,
        untilDate: inboundFlight.FlightDeparture.DepartureDate,
        station: outboundFlight.FlightDeparture.DepartureAirportRef.AirportCode,
        touroperator: offer.TourOperator.TourOperatorCode,
        searchOptions: searchOptions,
        selectedDestination: [hotel],
        parentid: offer.OfferID,
      })
    );
  };


  const betterOffers = useSelector(
    (state) => state.hotel.betterOffers[offer.OfferID]
  );

  const [showAlternatives, setShowAlternatives] = useState(false);
  const [shareOptionsHidden, setShareOptionsHidden] = React.useState(true);
 

  let checked = false;
  if (offer?.bookinginfo) checked = true;

  let transferincl = false;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferincl = true;
    }
  }
  let railandfly = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandfly = true;
    }
  }
  let txts = getTexts(offer.OfferProperties.OfferFeatures, [
    "Storno:",
    "Storno mit Gebühr:",
    "Umb:",
    "Opt Flex:",
    "Sonst:",
  ]);
  //console.log(txts);
  /*let cancellationText = "";
  let rebookingText = "";
  let addableText = "";
  if (offer.OfferProperties?.OfferFeatures) {
    cancellationText = offer.OfferProperties.OfferFeatures.split("Storno:")[1];
    if (cancellationText) {
      if (cancellationText.indexOf("Umb:") > -1) {
        cancellationText = cancellationText.split("Umb:")[0];
      }
      if (cancellationText.indexOf("Opt Flex:") > -1) {
        cancellationText = cancellationText.split("Opt ")[0];
      }
      cancellationText = cancellationText.trim();
      if (cancellationText.endsWith(",")) {
        cancellationText = cancellationText.split(",")[0];
      }
    }

    rebookingText = offer.OfferProperties.OfferFeatures.split("Umb:")[1];
    if (rebookingText) {
      if (rebookingText.indexOf("Opt Flex:") > -1) {
        rebookingText = rebookingText.split("Opt ")[0];
      }
      rebookingText = rebookingText.trim();
      if (rebookingText.endsWith(",")) {
        rebookingText = rebookingText.split(",")[0];
      }
    }
    addableText = offer.OfferProperties.OfferFeatures.split("Opt Flex:")[1];
    if (addableText) {
      addableText = addableText.trim();
      if (addableText.endsWith(",")) {
        addableText = addableText.split(",")[0];
      }
    }
  }*/

  let betteroffers = false;
  if (Array.isArray(betterOffers?.Offers?.Offer)) {
    if (betterOffers?.Offers?.Offer.length > 1) {
      betteroffers = true;
    }
  }

  let stopOversOutbound = [];
  let stopOversInbound = [];
  if (offer?.bookinginfo) {
    if (
      Array.isArray(
        offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
      )
    ) {
      if (
        Array.isArray(
          offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments[0]
            .Stopover
        )
      ) {
        stopOversOutbound = [
          ...offer?.bookinginfo?.Offer?.Package?.Flight
            ?.OutboundFlightSegments[0].Stopover,
        ];
      } else {
        stopOversOutbound = [
          {
            ...offer?.bookinginfo?.Offer?.Package?.Flight
              ?.OutboundFlightSegments[0].Stopover,
          },
        ];
      }
    } else {
      if (
        Array.isArray(
          offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
            ?.Stopover
        )
      ) {
        stopOversOutbound = [
          ...offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
            .Stopover,
        ];
      } else {
        stopOversOutbound = [
          {
            ...offer?.bookinginfo?.Offer?.Package?.Flight
              ?.OutboundFlightSegments.Stopover,
          },
        ];
      }
    }
  }

  if (offer?.bookinginfo) {
    if (
      Array.isArray(
        offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
      )
    ) {
      if (
        Array.isArray(
          offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments[0]
            .Stopover
        )
      ) {
        stopOversInbound = [
          ...offer?.bookinginfo?.Offer?.Package?.Flight
            ?.InboundFlightSegments[0].Stopover,
        ];
      } else {
        stopOversInbound = [
          {
            ...offer?.bookinginfo?.Offer?.Package?.Flight
              ?.InboundFlightSegments[0].Stopover,
          },
        ];
      }
    } else {
      if (
        Array.isArray(
          offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
            ?.Stopover
        )
      ) {
        stopOversInbound = [
          ...offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
            .Stopover,
        ];
      } else {
        stopOversInbound = [
          {
            ...offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
              .Stopover,
          },
        ];
      }
    }
  }



  let outboundWeight = 0;
  if (
    Array.isArray(
      offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.FlightSegment
    ) &&
    offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
      ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight
  ) {
    outboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight * 1;
  } else if (
    offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
      ?.FlightSegment?.BaggageAllowance?.MaxWeight
  ) {
    outboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.FlightSegment?.BaggageAllowance?.MaxWeight * 1;
  }
  let inboundWeight = 0;

  if (
    Array.isArray(
      offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.FlightSegment
    ) &&
    offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
      ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight
  ) {
    inboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight * 1;
  } else if (
    offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
      ?.FlightSegment?.BaggageAllowance?.MaxWeight
  ) {
    inboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.FlightSegment?.BaggageAllowance?.MaxWeight * 1;
  }
  let realprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    realprice = offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  }

  let status = 0;

  if (offer?.bookinginfo) {
    if (offer?.bookinginfo?.Status?.Status === "Available" || offer?.bookinginfo?.Status?.Status === "ToConfirm" || offer?.bookinginfo?.Status?.Status === "OnRequest") {
      status = 1;
    } else {
      status = -1;
    }
  }
  let outboundAirport = {};
  if (outboundFlight.FlightDeparture) {
    outboundAirport = airports.find(
      (e) =>
        e.StationCode ===
        outboundFlight.FlightDeparture.DepartureAirportRef.AirportCode
    );
  }

  let inboundAirport = {};
  if (inboundFlight.FlightDeparture) {
    inboundAirport = airports.find(
      (e) =>
        e.StationCode ===
        inboundFlight.FlightDeparture.DepartureAirportRef.AirportCode
    );
  }

  return (
    <>
      {" "}
      <div
        style={{
          display: "flex",
          border: "solid",
          borderWidth: "1px 0px 0px 0px",
          padding: "8px",
          marginTop: 16,
        }}
      >
        <div
          style={{
            minWidth: "20%",
            width: "20%",
            maxWidth: "20%",
            marginRight: 16,
          }}
        >
          <div className="tablerowDepartureTime">
            {df.format(new Date(offer?.TravelDateInfo?.DepartureDate))}
            &nbsp;-&nbsp;
            {df.format(new Date(offer?.TravelDateInfo?.ReturnDate))}&nbsp;(
            {offer?.TravelDateInfo?.TripDuration} Tage)
          </div>
          <div className="tablerowDepartureAirport">
            <FaPlaneDeparture />&nbsp;&nbsp;{outboundAirport.Name}
          </div>
          <div className="tablerowDepartureAirline">
            {outboundFlight?.Airline?.AirlineName ? <span>Airline&nbsp;&nbsp;</span> : null}{outboundFlight?.Airline?.AirlineName}
          </div>
        </div>
        <div
          style={{
            minWidth: "20%",
            width: "20%",
            maxWidth: "20%",
            marginRight: 16,
          }}
        >
          <div className="tablerowboardTyp">
            {propertyFromArray(
              boardTypes,
              offer.OfferServices.Package.Accommodation.BoardType,
              "value",
              "label"
            )}
          </div>
          <div className="tablerowRoomName">
            {offer.OfferServices.Package.Accommodation.Room.RoomName}
          </div>

          <div className="tablerowhotelofferofferroomsonst">
            {transferincl ? (
              <>
                <FormattedMessage id="transferincluded" />
                <br />
              </>
            ) : (
              <>
                <FormattedMessage id="transfernotincluded" />
                <br />
              </>
            )}{" "}
            {railandfly ? (
              <>
                Zug zum Flug
                <br />
              </>
            ) : null}
          </div>
          <div className="tablerowcancellationoptions">
            {<CancellationOptions offer={offer} />}
          </div>
        </div>
        <div
          style={{
            minWidth: "20%",
            width: "20%",
            maxWidth: "20%",
            marginRight: 16,
          }}
        >
          <img src={offer.TourOperator.TourOperatorImage} />
        </div>
        <div
          style={{
            minWidth: "10%",
            width: "10%",
            maxWidth: "10%",
            marginRight: 16,
          }}
        >
          {offer.PriceInfo.Price.value} {offer.PriceInfo.Price.CurrencyCode}
        </div>
        <div
          style={{
            minWidth: "30%",
            width: "30%",
            maxWidth: "30%",
            marginRight: 16,
          }}
        >
          <AvailabilityButton
            offer={offer}
            hotel={hotel}
            inboundView={views.hotelclassicview}
          />
        </div>
      </div>
      <div className={loading > 0 ? "load" : null} style={{ display: "flex" }}>
        <div style={{ flexGrow: 1 }}>
          {alternatives && (
            <>
              <span
                className="hotelofferframe3"
                onClick={() => {
                  if (!showAlternatives) {
                    getBetterOffers();
                    setShowAlternatives(true);
                  } else {
                    setShowAlternatives(false);
                  }
                }}
              >
                {!showAlternatives ? (
                  <span className="hotelofferframe4">
                    Bessere Leistungen &#x25B4;
                  </span>
                ) : (
                  <span className="hotelofferframe5">
                    Bessere Leistungen &#x25BE;
                  </span>
                )}
              </span>
            </>
          )}

        </div>
      </div>
      {betteroffers && showAlternatives && (
        <>
          <br />
          <div className="hotelofferframe14">
            {betterOffers.Offers.Offer.map((suboffer) => {
              let betterOption = checkBetter(offer, suboffer);

              //outboundFlight.FlightDeparture.DepartureTime
              return betterOption.better ? (
                //return true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                  }}
                >
                  <div style={{ flex: "20%" }}>
                    {propertyFromArray(
                      boardTypes,
                      suboffer.OfferServices.Package.Accommodation.BoardType,
                      "value",
                      "label"
                    )}
                  </div>
                  <div style={{ flex: "20%" }}>
                    {suboffer.OfferServices.Package.Accommodation.Room.RoomName}
                  </div>

                  {offer.OfferServices.Package.Accommodation.Room.RoomView !==
                    "NothingSpecial" ? (
                    <div style={{ flex: "20%" }}>
                      {propertyFromArray(
                        roomViews,
                        offer.OfferServices.Package.Accommodation.Room.RoomView,
                        "value",
                        "label"
                      )}
                    </div>
                  ) : null}

                  <div style={{ flex: "20%" }}>
                    {Array.isArray(suboffer.OfferProperties.TransferInfos) &&
                      suboffer.OfferProperties.TransferInfos.includes(
                        "TransferIncluded"
                      ) ? (
                      <>
                        <FormattedMessage id="transferincluded" />
                        <br />
                      </>
                    ) : (
                      <>
                        <FormattedMessage id="transfernotincluded" />
                        <br />
                      </>
                    )}
                  </div>
                  <div style={{ flex: "20%" }}>
                    {Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
                      suboffer.OfferProperties.OfferIncludes.includes(
                        "RailAndFly"
                      ) ? (
                      <>
                        Zug zum Flug
                        <br />
                      </>
                    ) : null}
                  </div>

                  <div style={{ flex: "20%" }}>
                    <FormattedNumber
                      value={
                        suboffer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1)
                      }
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />
                    &nbsp;{suboffer.PriceInfo.Price.CurrencyCode}
                  </div>
                  <div
                    style={{ flex: "0 0 3%", cursor: "pointer" }}
                    onClick={() => props.changeChoosenOffers(suboffer)}
                  >
                    auswählen
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </>
      )}

    </>
  );
}
